import React from "react";

function CustomCheckbox(props) {
  const { name, checked, onClick } = props;
  return (
    <div
      className="w-6 h-6 min-w-6 cursor-pointer rounded-full border border-txtGray"
      onClick={() => onClick(name)}
    >
      <div
        className={
          checked
            ? "bg-black w-full h-full transform scale-75 bg-gradient-to-r from-btnStart to-btnEnd rounded-full"
            : ""
        }
      />
    </div>
  );
}

export default CustomCheckbox;
